<div class="version-container">
  <div class="logout-wrapper">
    @if (helper.esNavidad()) {
      <img
        src="/assets/images/c-images/3020990.png"
        alt="decoración"
        class="side-image"
      />
    }
    <!-- Un ítem más del menú, no un botón destacado -->
    <button
      irxBoton="texto"
      bloque
      class="shell-cerrar-sesion"
      (click)="logout()"
    >
      <mat-icon>logout</mat-icon>
      Cerrar sesión
    </button>
    @if (helper.esNavidad()) {
      <img
        src="/assets/images/c-images/3020990.png"
        alt="decoración"
        class="side-image"
      />
    }
  </div>

  <div class="row-center" style="font-size: small; gap: 5px">
    <span
      class="ws-dot"
      [class.ws-dot--connected]="wsConnected()"
      [tooltip]="
        wsConnected() ? 'WebSocket conectado' : 'WebSocket desconectado'
      "
    ></span>

    <span>{{ version }}</span>

    @if (env.toLowerCase() !== 'prod') {
      <span>- {{ env }}</span>
    }
  </div>
</div>
